import { LoadingOutlined } from "@ant-design/icons";

import { handleTrackingButtonOnClick } from "./index";

export default function ButtonWithLoadingIcon({
  text,
  onClick,
  size,
  style,
  loading,
  success,
  error,
}: any) {
  let px = "px-3";
  let py = "py-2";
  let width = "w-24";
  let textSize = "text-base";

  switch (size) {
    case "sm":
      px = "px-2.5";
      py = "py-1.5";
      textSize = "text-sm";
      break;

    case "lg":
      px = "px-4";
      py = "py-2";
      break;

    case "full":
      width = "w-full";
      break;

    default:
      break;
  }

  const loadingIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

  const renderInnerComponent = () => {
    if (loading) {
      return loadingIcon;
    }
    if (success) {
      return text;
    }
    if (error) {
      return text;
    }
    return text;
  };

  return (
    <>
      <button
        type="button"
        className={`inline-flex items-center justify-center ${width} ${px} ${py} border border-transparent ${textSize} focus:outline-none rounded bg-indigo-600 font-medium text-white shadow-sm hover:bg-indigo-700 focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2`}
        onClick={() => handleTrackingButtonOnClick(text, onClick)}
        style={style}
      >
        {renderInnerComponent()}
      </button>
    </>
  );
}
